/* eslint-disable @typescript-eslint/no-explicit-any */

import { useCallback } from "react";
import { useNavigate } from "react-router";
import { useModulePathResolver } from "capitalrx-shell";

type NavState = [Function, any, Function];

/**
 * Wrap react-router history hook with the capitalrx module url path resolver.
 */
export const useHistory = (): NavState => {
  const navigateTo = useNavigate();
  const resolve = useModulePathResolver();

  const navigate = useCallback(
    (to: string | URL, options: any = {}): void => {
      const { replace = false, ...state } = options;

      if (replace) {
        navigate(to.toString(), {
          state,
        });
      }

      navigateTo(resolve(to.toString()), state);
    },
    [navigateTo, resolve],
  );

  /*

   navigate: use to 'push' or 'replace' urls (automatically does module resolution)
    history: this is the history object exposed by 'react-router'
    resolve: the module path resolver function

   */
  return [navigate, history, resolve];
};
